var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (model) {// iterate model.alertIds
;(function(){
  var $$obj = model.alertIds;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var alertId = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("data-ref", 'alert(' + alertId + ')', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var alertId = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("data-ref", 'alert(' + alertId + ')', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);
}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined));;return pug_html;};
module.exports = template;